export default "__VITE_ASSET__DmpOFh7s__"